export type PurchaseRequestStatusType =
  | 'SOURCING'
  | 'CALCULATING'
  | 'NEW'
  | 'SOURCED'
  | 'PRICE_CONFIRMATION_REQUESTED'
  | 'CONFIRMING_PRICE'
  | 'PRICE_CONFIRMED';

type StatusType = {
  value: PurchaseRequestStatusType;
  label: string;
};
export const StatusTypes: StatusType[] = [
  { value: 'NEW', label: 'New' },
  { value: 'SOURCING', label: 'Sourcing' },
  { value: 'CALCULATING', label: 'Calculating' },
  { value: 'SOURCED', label: 'Sourced' },
];

export const AllowedStatusTransitions: Record<PurchaseRequestStatusType, PurchaseRequestStatusType[]> = {
  NEW: ['SOURCING'],
  SOURCING: ['CALCULATING'],
  CALCULATING: ['SOURCED'],
  SOURCED: [],
  PRICE_CONFIRMATION_REQUESTED: ['CONFIRMING_PRICE'],
  CONFIRMING_PRICE: ['PRICE_CONFIRMED'],
  PRICE_CONFIRMED: [],
};
